import { Routing } from '../Routes';
import { Main } from '../Main/Main';
import { ProductListing } from '../ProductListing/ProductListing';
import { useFavorites } from '../../state/favorites';
import { LoaderPage } from './LoaderPage';
import { ErrorPage } from './ErrorPage';
import { useTranslation } from '../../i18n/i18n';
import { AccountPageNavigation } from '../AccountPageNavigation/AccountPageNavigation';

export const FavoritesPage = (): JSX.Element => {
	const { favorites, error, loading } = useFavorites();
	const t = useTranslation().favorite;

	if (loading) return <LoaderPage />;
	if (error) return <ErrorPage />;

	if (!favorites)
		return (
			<Main>
				<p>{t.noFavoritesShort}</p>;
			</Main>
		);

	return (
		<Main>
			<AccountPageNavigation />
			<h1 className="private-page-heading">{t.favorites}</h1>
			{favorites.length > 0 ? <ProductListing products={favorites} /> : <p>{t.noFavorites}</p>}
		</Main>
	);
};

export const favoritesRouting: Routing = {
	path(urls) {
		return urls.favorites;
	},
	component: FavoritesPage,
	requiresAuth: true,
};
